import classNames from 'classnames';
import React from 'react';
import { useHideGetItBy, useHideShipping } from '../hooks';

interface BottomFrameRuleProps {
  getItBy: string;
}

const BottomFrameRule: React.VFC<BottomFrameRuleProps> = ({
  getItBy
}: BottomFrameRuleProps) => {
  const hideShipping = useHideShipping();
  const hideGetItBy = useHideGetItBy(getItBy);
  const hideLine = hideGetItBy && hideShipping;

  return (
    <hr
      className={classNames('border-b border-grey-2 mb-12 mt-0 w-full', {
        invisible: hideLine
      })}
    />
  );
};

export default BottomFrameRule;
